import React, { useRef, useState } from "react";



import * as THREE from "three"
import { v } from "../../env/env_variable";

// const scale = 10000000
const orbitalElements = {
  semimajorAxis: 149598023/v.orbitScale,
  eccentricity: 0.01670/v.orbitScale,
  inclination: 0,
  meanRadius: 6371.00840/v.orbitScale,
}


function EllipticalOrbit({semimajorAxis, eccentricity, inclination, color}) {
    const points = [];
    // for (let index = 0; index < 64; index++) {
    //   const angle = (index / 64) * 2 * Math.PI;
    //   const x = xRadius * Math.cos(angle);
    //   const z = zRadius * Math.sin(angle);
    //   points.push(new THREE.Vector3(x, 0, z));
    // }

    // points.push(points[0]);

    semimajorAxis = semimajorAxis/v.orbitScale
    eccentricity = eccentricity/v.orbitScale
    inclination = (Math.PI / 180) * inclination

    const segments = 100;
    for (let i = 0; i <= segments; i++) {
      const trueAnomaly = (Math.PI * 2 * i) / segments;
      const radius = (semimajorAxis * (1 - eccentricity ** 2)) / (1 + eccentricity * Math.cos(trueAnomaly));
  
      const x = radius * Math.cos(trueAnomaly);
      const y = 0;
      const z = radius * Math.sin(trueAnomaly);;
  
      // Apply inclination if needed
      const inclinationMatrix = new THREE.Matrix4().makeRotationX(inclination);
      const position = new THREE.Vector3(x, y, z).applyMatrix4(inclinationMatrix);
  
      points.push(position);
    }
  


    const lineGeometry = new THREE.BufferGeometry().setFromPoints(points);

    return (
      <line geometry={lineGeometry}>
        <lineBasicMaterial attach="material" color={color} linewidth={1} />
      </line>
    );
}


export default EllipticalOrbit